/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Appointment identifier for a tour cancellation request. */
export type BuyerTourCancelInput = {
  /** Tour appointment to cancel. */
  id: Types.Scalars['NonEmptyString']['input'];
};

export type HubBuyerTourCancelMutationVariables = Exact<{
  input: Types.BuyerTourCancelInput;
}>;


export type HubBuyerTourCancelMutation = { buyerTourCancel:
    | { __typename: 'CommandResult', success: Types.Scalars['Boolean']['output'] }
    | { __typename: 'InvalidInputError' }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthorizedError' }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const HubBuyerTourCancelDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation HubBuyerTourCancel($input: BuyerTourCancelInput!) {
  buyerTourCancel(input: $input) {
    __typename
    ... on CommandResult {
      success
    }
  }
}
    `) as unknown as TypedDocumentString<HubBuyerTourCancelMutation, HubBuyerTourCancelMutationVariables>;